import { Map } from 'immutable';
import actionTypes from '../../actions/actionTypes';
import { OVERLAY_KEY_MULTISITE_SELECTOR, OVERLAY_SPINNER } from '../../constants/overlayTypes';
import { returnStateIfNoAction } from '../helpers';


const INIT_STATE = Map({
    [OVERLAY_KEY_MULTISITE_SELECTOR]: OVERLAY_SPINNER
})

const setType = (state, action) => {
    const { overlayKey, overlayType } = action.payload

    return state.set(overlayKey, overlayType)
}

const setReset = (state, action) => {
    const { overlayKey } = action.payload

    return state.set(overlayKey, false)
}


const overlayReducer = (state = INIT_STATE, action) => {
    returnStateIfNoAction(action, state) 

    switch(action.type) {
        case actionTypes.OVERLAY_SET_TYPE:
            return setType(state, action)
        case actionTypes.OVERLAY_SET_RESET:
            return setReset(state, action)
        default:
            return state;
    }
}

export default overlayReducer